export const SHOULD_REPLACE_HISTORY = import.meta.env.PROD
